/*
 * File: /src/services/companyServices.js
 * Created Date: Saturday June 15th 2019
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Monday, 9th December 2019 10:10:46 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */
import { authedAxios } from '../shared/axiosWrapper';
import { AD_BASE_COMPANY_PATH } from '../constants';

export default {
  /**
   * Get Company
   *
   * @param {*} id
   * @returns
   */
  fetchCompany(id) {
    return authedAxios.get(AD_BASE_COMPANY_PATH + id);
  },

  fetchAll() {
    return authedAxios.get(AD_BASE_COMPANY_PATH);
  },
  createCompany(company) {
    return authedAxios.post(AD_BASE_COMPANY_PATH, company);
  },

  /**
   * Update Company
   *
   * @param {*} id
   * @param {*} company
   * @returns
   */
  updateCompany(id, company) {
    return authedAxios.put(AD_BASE_COMPANY_PATH + id, company);
  },

  /**
   * Fetch the Company Logo
   *
   * @returns
   */
  fetchCompanyLogoUrl() {
    return authedAxios.get(AD_BASE_COMPANY_PATH + 'logo/');
  },

  /**
   * Fet the API token
   *
   * @returns
   */
  fetchCompanyApiToken(type) {
    return authedAxios.get(AD_BASE_COMPANY_PATH + 'token/' + type);
  },

  /**
   * Generate API Token
   *
   * @param {*} type
   * @returns
   */
  generateApiToken(type) {
    return authedAxios.post(AD_BASE_COMPANY_PATH + 'token/' + type);
  },

  /**
   * Path for Posting Company Image
   *
   * @returns
   */
  postCompanyImage(id) {
    return AD_BASE_COMPANY_PATH + 'logo/' + id + '/';
  },

  /**
   * Delete Company Logo
   *
   * @returns
   */
  deleteCompanyLogo(id) {
    return authedAxios.delete(AD_BASE_COMPANY_PATH + 'logo/' + id + '/');
  },

  /**
   * Check Valid Domains
   *
   * @returns
   */
  checkDomains() {
    return authedAxios.get(AD_BASE_COMPANY_PATH + 'valid-domains/check-email');
  },

  /**
   * Checks for a validated primary email
   *
   * @returns
   */
  checkPrimary() {
    return authedAxios.get(AD_BASE_COMPANY_PATH + 'valid-domains/check-primary');
  },

  /**
   * List Domain Types
   *
   * @param {*} type
   * @returns
   */
  listDomains(type) {
    return authedAxios.get(AD_BASE_COMPANY_PATH + 'valid-domains/' + type);
  },

  /**
   * List Domain Types
   *
   * @param {*} type
   * @returns
   */
  listDomainsByCompany(id, type) {
    return authedAxios.get(
      AD_BASE_COMPANY_PATH + 'valid-domains/co/' + type + '/' + id
    );
  },

  /**
   * Add Domain
   *
   * @param {*} type
   * @param {*} body
   * @returns
   */
  addDomain(type, body) {
    return authedAxios.post(AD_BASE_COMPANY_PATH + 'valid-domains/' + type, body);
  },

  addDomainsByCompany(id, type, body) {
    return authedAxios.post(
      AD_BASE_COMPANY_PATH + 'valid-domains/co/' + type + '/' + id,
      body
    );
  },

  /**
   * Update Domain
   *
   * @param {*} type
   * @param {*} body
   * @returns
   */
  updateDomain(type, id, body) {
    return authedAxios.put(
      AD_BASE_COMPANY_PATH + 'valid-domains/' + type + '/' + id,
      body
    );
  },

  /**
   * Delete Domain
   *
   * @param {*} type
   * @param {*} id
   * @returns
   */
  deleteDomain(type, id) {
    return authedAxios.delete(
      AD_BASE_COMPANY_PATH + 'valid-domains/' + type + '/' + id
    );
  },

  /**
   * Fetch Domain
   *
   * @param {*} type
   * @param {*} id
   * @returns
   */
  fetchDomain(type, id) {
    return authedAxios.get(
      AD_BASE_COMPANY_PATH + 'valid-domains/' + type + '/' + id
    );
  },

  /**
   * Add a UUID for a WiFi Access Point
   *
   * @param {*} uuid
   * @returns
   */
  addWifiUuid() {
    return authedAxios.post(AD_BASE_COMPANY_PATH + 'valid-domains/wifi', {
      wifi: 'newUuid'
    });
  }
};
